import { render, staticRenderFns } from "./BrowseGoalsResults.vue?vue&type=template&id=08e30af9&scoped=true"
import script from "./BrowseGoalsResults.vue?vue&type=script&lang=js"
export * from "./BrowseGoalsResults.vue?vue&type=script&lang=js"
import style0 from "./BrowseGoalsResults.vue?vue&type=style&index=0&id=08e30af9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e30af9",
  null
  
)

export default component.exports